/**
 * Pashion: mounts the Stylux personalization CTA on "stylux"-template PDPs.
 *
 * snippets/stylux-pdp.liquid renders an empty #stylux-offer-container with the
 * current variant id. Broadcast re-renders the whole product section on every
 * option change (section rendering API), so the container is replaced and the
 * offer has to be shown again. We hook Broadcast's <product-info>
 * postProcessHtmlCallbacks (same pattern as pashion-bundle-pdp.js) and keep a
 * MutationObserver as a fallback.
 *
 * Requires window.Stylux from snippets/stylux-head.liquid (US only).
 */
(function () {
  'use strict';

  var SELECTOR = '[data-stylux-offer]';

  function mount() {
    var container = document.querySelector(SELECTOR);
    if (!container || container.getAttribute('data-stylux-mounted') === container.getAttribute('data-stylux-variant')) return;
    if (!window.Stylux || !window.Stylux.offers || typeof window.Stylux.offers.show !== 'function') return;

    var variantId = Number(container.getAttribute('data-stylux-variant')) || null;
    if (!variantId) return;

    container.setAttribute('data-stylux-mounted', String(variantId));
    container.innerHTML = '';

    Promise.resolve(window.Stylux.waitForDOMElements ? window.Stylux.waitForDOMElements() : null).then(function () {
      window.Stylux.offers.show({
        productId: variantId,
        elementClasses: container.getAttribute('data-stylux-classes') || 'stylux-offer-btn btn btn--large btn--solid btn--black btn--full'
      });
    });
  }

  function hookProductInfo() {
    var productInfo = document.querySelector('product-info');
    if (productInfo && productInfo.postProcessHtmlCallbacks && !productInfo.__styluxHooked) {
      productInfo.__styluxHooked = true;
      productInfo.postProcessHtmlCallbacks.push(function () { mount(); });
    }
  }

  function start() {
    hookProductInfo();
    mount();

    // Fallback: any DOM swap that brings in a fresh (unmounted) container
    var observer = new MutationObserver(function () {
      var c = document.querySelector(SELECTOR);
      if (c && !c.hasAttribute('data-stylux-mounted')) {
        hookProductInfo();
        mount();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function whenStyluxReady(fn) {
    if (window.Stylux && window.Stylux.offers) { fn(); return; }
    if (window.Stylux && typeof window.Stylux.onScriptLoad === 'function') { window.Stylux.onScriptLoad(fn); return; }
    // SDK loader not present (non-US or not a stylux template): nothing to do
  }

  function init() { whenStyluxReady(start); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('theme:product-info:loaded', hookProductInfo);
})();
